import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit, Input, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login/login.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, BehaviorSubject, debounceTime, startWith, switchMap, tap, merge, distinctUntilChanged } from 'rxjs';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { PlanProtectionDialogComponent } from '../../dialogs/plan-protection-dialog/plan-protection-dialog.component';
import { NuevoPlanProtectionDialogComponent } from '../../dialogs/nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { VisualizadorPlanProtectionDialogComponent } from '../../dialogs/visualizador-plan-protecion/visualizador-plan-protection-dialog.component';
import { VisualizadorImgDialogComponent } from '../../../app/dialogs/visualizador-img-dialog/visualizador-img-dialog.component';

@Component({
  selector: 'app-historial-servicios',
  templateUrl: './historial-servicios.html',
  styleUrls: ['./historial-servicios.scss']
})

export class HistorialServiciosComponent { 

  listaImagenes = [] 
  @ViewChildren('scrollContainer') scrollContainers!: QueryList<ElementRef>;
  @Input() planPro: any
  banderaInicial = true
  historial = []
  serviciosDetalle = [
    {
      "servicioSkuId": 13728,
      "label": "Rotaciones",
      "descripcion": "Rotaciones",
      "iconClass": "balanceo",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "rotacion",
      "img": "../../../assets/icons/balanceo.png"
    },
    {
      "servicioSkuId": 13729,
      "label": "Balanceos",
      "descripcion": "Balanceos",
      "iconClass": "parchado",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "balanceo",
      "img": "../../../assets/icons/parchado.png"
    },
    {
      "servicioSkuId": 13730,
      "label": "Diag. Mecánico",
      "descripcion": "Diagnóstico Mecánico",
      "iconClass": "diagnostico-mecanico",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "diagnostico",
      "img": "../../../assets/icons/diagnostico-mecanico.png"
    },
    {
      "servicioSkuId": 13732,
      "label": "Nitrógeno",
      "descripcion": "Llenado de Nitrógeno",
      "iconClass": "nitrogeno",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "nitrogeno",
      "img": "../../../assets/icons/nitrogeno.png"
    },
    {
      "servicioSkuId": 13733,
      "label": "Parchado",
      "descripcion": "Servicio de Parchado",
      "iconClass": "rotaciones",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "parchado",
      "img": "../../../assets/icons/rotacion.png"
    },
    {
      "servicioSkuId": 38662,
      "label": "Garantía",
      "descripcion": "Garantía",
      "iconClass": "garantia",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "garantia",
      "img": "../../../assets/icons/garantia.png"
    }
  ]
  historialOriginal = []
  selectedSkuIds = [];
  servicios = [
    {
      "servicioSkuId": 13728,
      "descripcion": "Rotaciones",
      "iconClass": "balanceos"
    },
    {
      "servicioSkuId": 13729,
      "descripcion": "Balanceos",
      "iconClass": "parchado"
    },
    {
      "servicioSkuId": 13730,
      "descripcion": "Diagnostico Mecanico",
      "iconClass": "diagnostico-mecanico"
    },
    {
      "servicioSkuId": 13732,
      "descripcion": "Llenado de Nitrogeno",
      "iconClass": "nitrogeno"
    },
    {
      "servicioSkuId": 13733,
      "descripcion": "Servicio de Parchado",
      "iconClass": "rotaciones"
    },
    {
      "servicioSkuId": 38662,
      "descripcion": "Garantía",
      "iconClass": "garantia"
    }
  ]
  isDesktop = false

  constructor(private ppService: PlanProtectionService, private dialog: MatDialog, private spinnerService: SpinnerService){
   const ua = navigator.userAgent;
    if (/mobile/i.test(ua)) {
      this.isDesktop = false;
    } else if (/tablet/i.test(ua)) {
      this.isDesktop = false;
    } else {
      this.isDesktop = true;
    }
  }


  scrollLeft(idx) {
    const container = this.scrollContainers.toArray()[idx];
    container.nativeElement.scrollBy({ left: -200, behavior: 'smooth' });
  }

  scrollRight(idx) {
    const container = this.scrollContainers.toArray()[idx];
    container.nativeElement.scrollBy({ left: 200, behavior: 'smooth' });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['planPro']) {
      if(this.banderaInicial){
        let body ={
          EmpresaId: this.planPro.empresaId,
          OrdenVentaPlanProtectionId: this.planPro.ordenVentaPlanProtectionId,
          SkuPlanProtection: this.planPro.skuPlanProtection
        }
        // let body = {
        //   "EmpresaId": 2,
        //   "OrdenVentaPlanProtectionId": 12690,
        //   "SkuPlanProtection": "1"
        // }
        this.banderaInicial = false
        this.ppService.getHistorialGarantia(body).subscribe(
          data => {
            let auxFechas = data.fechas.sort((a, b) => {
              const fechaA = new Date(a.fechaUso);
              const fechaB = new Date(b.fechaUso);
              return fechaA.getTime() - fechaB.getTime(); // ascendente
              // return fechaB.getTime() - fechaA.getTime(); // descendente
            })
            auxFechas.forEach(element => {
              let serv = this.servicios.find(item => item.servicioSkuId === element.servicioSkuId);
              
              let auxFilespath = element.filesPaths.filter(filePath => !filePath.includes('.pdf'));
              let existeHistorial
              if(serv.servicioSkuId === 13728 || serv.servicioSkuId === 13729 || serv.servicioSkuId === 13730){
                existeHistorial = this.historial.some(
                  el => el.servicioSkuId === serv.servicioSkuId && el.fecha === element.fechaUso
                );
              }
              
              if(existeHistorial){
              }else{
                this.historial.unshift({
                  servicioSkuId: serv.servicioSkuId,
                  descripcion: serv.descripcion,
                  iconClass: serv.iconClass,
                  filespaths: auxFilespath,
                  fecha: element.fechaUso,
                  usuario: element.nombreUsuario !== '' ? element.nombreUsuario : 'Sin información',
                  cliente: element.cliente !== '' ? element.cliente : 'Sin información',
                  sucursal: element.nombreSucursal !== '' ? element.nombreSucursal : 'Sin información'
                })
              }
            });

            data.detallePP.forEach(element => {
              let serv = this.serviciosDetalle.find(item => item.servicioSkuId === element.servicioSkuId);

              serv.cantidadDisponible = element.cantidad - element.usos
              // serv.cantidadDisponible = 2
              serv.cantidadTotal = element.cantidad
            });
            this.historialOriginal = this.historial
          }
        )
      }
    }
  }


  getDate(dateInput: string | Date): string {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const normalize = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const normalizedDate = normalize(date);
    const normalizedToday = normalize(today);
    const normalizedYesterday = normalize(yesterday);

    if (normalizedDate.getTime() === normalizedToday.getTime()) {
      return 'Hoy';
    } else if (normalizedDate.getTime() === normalizedYesterday.getTime()) {
      return 'Ayer';
    } else {
      return date.toLocaleDateString('es-MX');
    }
  }

  getTime(dateInput: string | Date): string {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    return date.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
  }

  filtrar() {
    if(this.selectedSkuIds.length === 0){
      this.historial = this.historialOriginal
    } else{
      this.historial = this.historialOriginal.filter(element => this.selectedSkuIds.includes(element.servicioSkuId) ); 
    }
  }

  toggleSku(skuId) {
    if (this.selectedSkuIds.includes(skuId)) {
      // quitar si ya estaba
      this.selectedSkuIds = this.selectedSkuIds.filter(id => id !== skuId);
    } else {
      // agregar si no estaba
      this.selectedSkuIds.push(skuId);
    }
    this.filtrar()
  }

  abrirImagen(filepaths, i) {
    
    this.dialog.open(VisualizadorImgDialogComponent, {
      // width: '100vw',
      // height: '100vh',z
      data: { imgs: filepaths.filespaths, indexSelected: i },
      panelClass: 'custom-dialog',
    });
  }
}
